<template>
  <div class="w-full flex items-center gap-1.5 p-1.5 rounded-md bg-neutral-25 min-w-0">
    <component :is="platformIcon" class="text-icon-normal flex-shrink-0" />
    <BaseText type="body" size="sm" class="text-text-normal flex-grow truncate">
      {{ verbose ? "You're viewing" : "Viewing" }} {{ platformName }} presets
    </BaseText>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { platformNameMap, platformIconMap } from '@/utils/lens/dataSourceUtils'

export default {
  name: 'PresetDropdownFooter',
  props: {
    verbose: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters('MetricsModule', ['getMetricsPlatform']),
    platformName () {
      return platformNameMap[this.getMetricsPlatform]
    },
    platformIcon () {
      return platformIconMap[`mono-${this.getMetricsPlatform}`]
    }
  }
}
</script>